import React, { useState, useEffect, useRef, useMemo } from 'react';
import logo from '../../Images/metropolis-logo.png';
import removelogo from '../../Images/metropolis-logo-removebg.png';
import innerlogo from '../../Images/login-logo30.png';
import removeinnerlogo from '../../Images/login-logo30.removebg.png';
import hitechleftmenu from '../../Images/hitech-left-menu-icon.png';
import { FaTachometerAlt, FaRegCircle, FaAngleRight, FaAngleDown, FaList } from "react-icons/fa";
import { store } from '../../Store/store';
import * as FaIcons from "react-icons/fa"; // Import all icons
import { useLocation } from 'react-router-dom'; // To detect current URL
import { AlignLeftIcon } from 'lucide-react';
import "./LeftMenuComponent.css"
import { useAPSCMetlinkRights, useInvoiceTotalOutstanding, usePayARCMetlinkRights, useRateCardRights, useTransactionsRights } from '../../Common/CommonAccessFile';

const LeftMenuComponent = ({ ToggleMenu, ToggleMobileMenu, MenuStyle, isLeftsidebar }) => {
    const accessToRateCard_Rights = useRateCardRights();
    const accessToTransactions = useTransactionsRights();
    const accessToAPSCMetlink = useAPSCMetlinkRights();
    const accessToARCMetlink = usePayARCMetlinkRights();
    const hostname = window.location.hostname;

    const isHitechEnv =
        // hostname === "localhost" ||
        hostname === "partners.hitechlabsindia.in";

    const dynamicRemoveLogo = isHitechEnv
        ? "https://s3.ap-south-1.amazonaws.com/mhl-partner/Hitech.png"
        : removelogo;

    const dynamicInnerLogo = isHitechEnv
        ? hitechleftmenu
        : removeinnerlogo;


    const menuRef = useRef(null);

    let userLoginInfo = store.getState();

    // const userInfo = useMemo(() => {
    //     if (!accessToRateCard_Rights && !accessToTransactions && userLoginInfo?.MenuData) {
    //         return {
    //             ...userLoginInfo,
    //             MenuData: userLoginInfo.MenuData.filter(
    //                 menu =>
    //                     !menu?.MenuName?.toLowerCase().includes('rate card') &&
    //                     !menu?.URL?.toLowerCase().includes('ratecard')
    //                     // !menu?.MenuName?.toLowerCase().includes('financials') &&
    //                     // !menu?.URL?.toLowerCase().includes('transactions')
    //             )
    //         };
    //     }
    //     return userLoginInfo;
    // }, [accessToRateCard_Rights, accessToTransactions, userLoginInfo]);

    const userInfo = useMemo(() => {
        if ((!accessToRateCard_Rights || !accessToTransactions || !accessToAPSCMetlink || !accessToARCMetlink) && userLoginInfo?.MenuData) {
            return {
                ...userLoginInfo,
                MenuData: userLoginInfo.MenuData.filter(menu => {
                    if (!accessToRateCard_Rights) {
                        if (
                            menu?.MenuName?.toLowerCase().includes('rate card') ||
                            menu?.URL?.toLowerCase().includes('ratecard')
                        ) return false;
                    }
                    if (!accessToTransactions) {
                        if (
                            menu?.MenuName?.toLowerCase().includes('financials') ||
                            menu?.URL?.toLowerCase().includes('transactions')
                        ) return false;
                    }
                    // if (!accessToAPSCMetlink) {
                    //     if (
                    //         menu?.MenuName?.toLowerCase().includes('apsc metlink report') ||
                    //         menu?.URL?.toLowerCase().includes('metlink_report_apsc')
                    //     ) return false;
                    // }
                    // if (!accessToARCMetlink) {
                    //     if (
                    //         menu?.MenuName?.toLowerCase().includes('arc metlink report') ||
                    //         menu?.URL?.toLowerCase().includes('metlink_report_arc')
                    //     ) return false;
                    // }
                    return true;
                })
            };
        }
        return userLoginInfo;
    }, [accessToRateCard_Rights, accessToTransactions, userLoginInfo]);

    const location = useLocation(); // <-- get current location
    const [isToggled, setIsToggled] = useState(false);
    const [selectedMenu, setSelectedMenu] = useState(location.pathname); //
    const [openMenuId, setOpenMenuId] = useState(null);
    const [lastOpenMenuId, setLastOpenMenuId] = useState(null); // Remember last opened menu

    // Handles closing the menu when clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                isToggled // Only close submenu on outside click when sidebar is collapsed
            ) {
                setOpenMenuId(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isToggled]); // Only depend on isToggled

    useEffect(() => {
        const wasToggled = isToggled;

        if (MenuStyle.includes('toggled')) {
            // Sidebar is being collapsed
            if (!wasToggled && openMenuId) {
                // Remember the currently open menu before collapsing
                setLastOpenMenuId(openMenuId);
            }
            setIsToggled(true);
        } else {
            // Sidebar is being expanded
            setIsToggled(false);
            // Restore the last opened menu after a short delay to ensure transition
            setTimeout(() => {
                if (lastOpenMenuId) {
                    setOpenMenuId(lastOpenMenuId);
                }
            }, 100);
        }
    }, [MenuStyle, openMenuId, lastOpenMenuId]);

    useEffect(() => {
        setSelectedMenu(location.pathname);

        // Auto-expand parent only if sidebar is NOT toggled
        if (!isToggled) {
            const matchedParent = userInfo.MenuData?.find((menu) =>
                menu.SubMenus?.some((sub) => sub.URL === location.pathname)
            );

            if (matchedParent) {
                setOpenMenuId(matchedParent.Id);
                setLastOpenMenuId(matchedParent.Id); // Remember this menu
            }
        } else {
            // Collapse all submenus when sidebar is toggled
            setOpenMenuId(null);
        }
    }, [location, userInfo.MenuData, isToggled]);

    const handleMenuClick = (URL) => {
        //console.log("handleMenuClick", URL)
        setSelectedMenu(URL); // <-- update selected manually on click
    };

    const handleParentMenuClick = (menuInfo) => {
        if (menuInfo.Is_Parent) {
            if (openMenuId === menuInfo.Id) {
                // User is closing this menu, so clear both open and last open menu
                setOpenMenuId(null);
                setLastOpenMenuId(null); // <-- Clear this to avoid restoring
            } else {
                setOpenMenuId(menuInfo.Id);
                setLastOpenMenuId(menuInfo.Id); // Remember this menu
            }
        }
    };


    return (<>
        {!isToggled && <div className="sidebar-overlay d-md-none" onClick={() => ToggleMobileMenu && ToggleMobileMenu()}></div>}
        <div ref={menuRef} style={{ position: 'relative', zIndex: 1001 }}>
            <ul className={`menu d-flex d-md-block align-items-lg-start align-items-center h-100 w-lg-auto flex-grow-0 ${MenuStyle} animate-in animate-out`} id="accordionSidebar" >

                {/* Sidebar - Brand */}
                {!isLeftsidebar ? (
                    <div className="sidebar-brand d-flex justify-content-center align-items-center">
                        {/* <div className="sidebar-brand d-flex align-items-center"> */}
                        <div>
                            <a href="/dashboard">
                                {/* <img className="sidebar-brand-text" src={removelogo} alt="Logo" width={170} /> */}
                                <img className="sidebar-brand-text" src={dynamicRemoveLogo} alt="Logo" style={{padding:"10px"}} width={170} />

                            </a>
                        </div>
                        <div>
                            <button className="rounded-circle border-0 m-0 cursor-pointer" id="sidebarToggle" onClick={() => ToggleMenu()}></button>
                        </div>
                    </div>
                ) : <div className="sidebar-brand d-flex justify-content-center align-items-center">
                    <a href='/dashboard'>
                        {/* <img className="d-none d-md-block" src={removeinnerlogo} alt="Logo" width={75} /> */}
                        <img className="d-none d-md-block" src={dynamicInnerLogo} alt="Logo" width={75} />

                    </a>
                    <div className='d-flex align-items-center justify-content-between w-100 mobile-logo-wrapper'>
                        <a href="/dashboard">
                            {/* <img className="sidebar-brand-text" src={removelogo} alt="Logo" width={170} /> */}
                            <img className="sidebar-brand-text" src={dynamicRemoveLogo} alt="Logo" width={170} />

                        </a>
                        <div className='d-md-none'>
                            <button
                                className="rounded-circle border-0 m-0 cursor-pointer d-md-none"
                                id="sidebarToggle"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (ToggleMobileMenu) ToggleMobileMenu();
                                    else ToggleMenu();
                                }}
                                style={{ position: 'relative', zIndex: 1001 }}
                            ></button>
                        </div>
                    </div>
                </div>
                }

                <hr className="sidebar-divider my-0 mb-3" />

                <li className={`nav-item cursor-pointer menu-title ${selectedMenu === '/dashboard' ? 'active selected-menu' : ''}`}>
                    <a className="nav-link" href="/dashboard" onClick={() => handleMenuClick('/dashboard')}>
                        <div className={`d-flex align-items-center ${isToggled ? "flex-column" : "flex-row gap-2"}  menu-title-btn`}>
                            <FaTachometerAlt className='menu-icon' />
                            <span style={{ fontSize: '14px' }}>Dashboard</span>
                        </div>
                    </a>
                </li>

                {userInfo.MenuData?.map((menuItem) => {
                    const IconComponent = FaIcons[menuItem.Icon] || FaIcons.FaRegCircle;
                    const isParentActive = menuItem.SubMenus?.some(sub => sub.URL === selectedMenu); //highlights parent of the active submenu
                    return (
                        <>
                            {menuItem.Is_Parent ? (
                                <>

                                    <li key={menuItem.Id} className={`nav-item ${isParentActive ? 'active' : ''}`}>
                                        <div className='text-white d-flex align-items-center submenu-title'>
                                            <a
                                                className={`nav-link menu-title-btn  d-flex align-items-center  ${openMenuId === menuItem.Id ? '' : 'collapsed'} ${!isToggled ? "flex-column" : "flex-row gap-2"}`}
                                                onClick={() => handleParentMenuClick(menuItem)}
                                                data-toggle="collapse"
                                                aria-expanded={openMenuId === menuItem.Id}
                                            >
                                                <div className='d-flex justify-content-between align-items-center menu-title-btn w-100'>
                                                    <IconComponent />
                                                    <div className='d-flex align-items-center justify-content-between justify-content-md-center w-100'>
                                                        <span>{menuItem.MenuName}</span>
                                                        {isToggled && <FaAngleRight className=" ms-1" />}
                                                        <FaAngleDown className='d-md-none' />
                                                    </div>

                                                </div>
                                            </a>
                                        </div>
                                        <div
                                            className={`collapse ${openMenuId === menuItem.Id ? 'show' : ''}`}
                                            id={`collapse-${menuItem.Id}`}
                                        >
                                            <div className="bg-white collapse-inner rounded custom-collapse-inner">
                                                {menuItem.SubMenus.map((sub, index) => {
                                                    const SubIcon = sub.Icon ? FaIcons[sub.Icon] : FaIcons.FaRegCircle;
                                                    return (
                                                        <a
                                                            key={index}
                                                            href={sub.URL || '#'}
                                                            className={`collapse-item m-0 ${selectedMenu === sub.URL ? 'active' : ''}`}
                                                            onClick={() => setSelectedMenu(sub.URL)}
                                                        >
                                                            <SubIcon className="me-2" />
                                                            {sub.SubMenu_Name}
                                                        </a>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </li>

                                </>
                            ) : (
                                <li key={menuItem.Id} className={`nav-item menu-title ${selectedMenu === menuItem.URL ? 'active selected-menu' : ''}`}>
                                    <a
                                        className="nav-link"
                                        href={menuItem.URL}
                                        onClick={() => handleParentMenuClick(menuItem)}
                                    >
                                        <div className={`d-flex ${isToggled ? "flex-column" : "flex-row gap-2"}  align-items-center menu-title-btn`}>
                                            <IconComponent className="" />
                                            <span style={{ fontSize: '13px' }}>{menuItem.MenuName}</span>
                                        </div>
                                    </a>
                                </li>
                            )}
                        </>
                    );
                })}
            </ul>
        </div>
    </>
    );
};

export default LeftMenuComponent;